// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".labelAzul {\n  color: rgb(32, 32, 104);\n}", "",{"version":3,"sources":["webpack://src/pages/configuracaoTarefa/ConfiguracaoTarefa.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB","sourcesContent":[".labelAzul {\n  color: rgb(32, 32, 104);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
